window.APP_CONFIG = {
  baseUrl: "https://djbvts.watsoo.com/backend/",
  // baseUrl: "http://192.168.60.198:8082/",
  // ...add other config values as needed
};
module.exports = {
  /* ============================ DJB STAGING===================================*/

  // baseUrlGps:'http://192.168.200.16:8083/',
  // baseUrlGps: "https://djbstaging.watsoo.com/watsoo-traccar/",
  // baseUrl: "https://djbstaging.watsoo.com/backend/",

  /* ====================PRODUCTION================ */

  baseUrlGps: "https://djbvts.watsoo.com/watsoo-traccar/",
  baseUrl: "https://djbvts.watsoo.com/backend/",
  // baseUrl: "http://192.168.60.242:8082/",

  // baseUrl:"http://192.168.60.232:8085/",
  //  baseUrl: "http://192.168.60.207:8082/",
  // baseUrl:'http://192.168.30.35:6789/djb-vts-old/',

  /* =================END============================== */

  Username: "admin",
  Password: "W@ts00@2026!#",
  apiKey:
    window.location.hostname === "localhost" ||
      window.location.hostname.startsWith("192.")
      ? "AIzaSyDL9J82iDhcUWdQiuIvBYa0t5asrtz3Swk"
      : "AIzaSyD5y7I25p_GnEpt_mcLV30lLJGbpmDU6Dw",
  // "AIzaSyD5y7I25p_GnEpt_mcLV30lLJGbpmDU6Dw",
  NkcWeb: false,
  VTSWeb: false,
  BJBWeb: true,
  agencyName: "Agency",
  vehicleName: "Tanker",
  siteName: "Emergency",
  version: "25.001",
  showConsole:
    window.location.hostname === "localhost" ||
      window.location.hostname.startsWith("192.")
      ? false
      : true,
  AesKey: "77217A25432A462D4A614E635266556A",
  loginTime: 45,
  expireTime: 60,

  // Api endpoint name
  apiName: {
    getAllZoneMaster: "api/v1/all/zone_master",
    divisionAll: "api/division/all",
    divisionAdd: "api/division/add",
    vehicleReplace: "dpl/v1/replace",
    fetchWardName: "ward/v1/getAll",
    // addDPL: "dpl/v3",
    // addDPL: "dpl/v1/add_update",
    addDPL: "dpl/v2/add_update",
    fetchAddressBook: "dpl/v1/getById",
    UpdateDistance: "api/v1/update/distance",
    UploadFileOnAWs: "uploadFile",
    // loginApi:'v1/login',
    loginApi: "v2/login",
    logout: "v1/logout",
    UserList: "api/v1/user/all",
    AddUser: "api/v1/user/add",
    ActiveUser: "api/v1/user/active/inactive",
    UpdateUser: "api/v1/user/update",
    GetUserById: "api/v1/user",
    DesignationList: "v1/designation",
    UpdateDpl: "api/v1/update/dpl",
    permission_category: "v1/permission_category",
    RoleList: "v1/role/all",
    SiteList: "api/v3/site/all",
    AddSiteAccess: "api/v1/add/user/site/role",
    RemoveSiteAccess: "api/v1/remove/user/site/role",
    AddRole: "v1/role/add",
    VehicleList: "api/v2/vehicle/all", // vehicle list
    VehicleListLite: "api/v2/vehicle/all/lite", // vehicle list lite

    ViewTrip2: "api/v2/etp/orders/get/all",
    VehicleTypeList: "api/v1/all/vehicle-type",
    ActiveVehicle: "api/v1/vehicle/active/inactive",
    AddVehicle: "api/v1/vehicle/add",
    VehicleById: "api/v1/vehicle/view",
    UpdateVehicle: "api/v1/vehicle/update",
    VendorList: "api/v1/vendor/all",
    AddVendor: "api/v1/vendor/add",
    UpdateVendor: "api/v1/vendor/update",
    VendorById: "api/v1/vendor/view",
    ActiveVendor: "api/v1/vendor/active/inactive",
    DriverList: "api/v1/driver/all",
    DocumentList: "api/v1/documents/all",
    RouteList: "api/v1/route/all",
    AddRoute: "api/v1/route/add",
    ActiveRoute: "api/v1/route/active/inactive",
    RouteById: "api/v1/route/id",
    UpdateRoute: "api/v1/route/update",
    SyncVehicle: "api/v1/sync/vehicle",
    DeleteFile: "deleteFiles",
    EtpOrder: "api/v1/etp/orders/view",
    TotalVendorDashboard: "api/v1/dashbord/status",
    fetchAddress: "address/v1/fetch_address",
    totalInstallGps: "api/v1/dashbord/vehicle/status",
    removeGeoFench: "api/v1/delete/geofence",
    CreateTrip: "api/v1/etp/orders/create",
    TripList: "v1/get/schedule/trips",
    MaterialType: "api/v1/all/material-type",
    DestinationTripSite: "api/v1/get_destinations_from_source",
    ViewTrip: "api/v1/etp/orders/view",
    MissedTrip: "v1/get/missed/trips",
    NotificationAlert: "api/v1/alert/get_all",
    KmlFileUploding: "api/uploadKmlData",
    getFuelDashboard: "getFuelDashboard",
    routeSiteSubSite: "api/v4/site/route/sub_site/all",
    removeGpsFromVehicle: "api/v1/remove/vehicle",
    routeDetele: "api/v1/route/delete",
    auditLog: "api/v1/auditLog",
    AllpermissionName: "api/v1/permission",
    ActiveRoutes: "api/v1/get/active/routes",
    UptimeReport: "api/v1/vehicle/active/inactive/history",
    maintenanceVehicleList: "api/v1/vehicle/maintenance/category",
    maintenanceAdd: "api/v1/vehicle/maintenance/add",
    ZoneList: "api/v1/getAll/zone",
    getZone: "api/v1/get/zone",
    addZone: "api/v1/add/zone",
    updateZone: "api/v1/update/zone",
    saveTripSchedule: "v1/saveTripSchedule",
    getAllSchedule: "v1/getAllSchedule",
    deactiveById: "v1/deactiveById",
    addRemark: "v1/save/trip/remarks",
    saveAgreement: "agreement/v1/save",
    updateAgreement: "agreement/v1/update",
    AgreementList: "agreement/v1/getAll",
    AgreementById: "agreement/v1/getById",
    ApproveRejectTrip: "v1/approve/status",
    anotherTripAdd: "api/v1/add/vendor/trip/change",
    guestVehicle: "api/v1/get/vehicle/live/track",
    searchDplName: "api/v1/search/dpl",
    priorList: "prior/v1/get/trip/All",
    addPrior: "prior/v1/add/trip",
    viewPrior: "prior/v1/get/trip/by/id",
    PriorApprove: "prior/v1/approve/status",
    constituencyList: "v1/get/all/constituency",
    addconstituencyInVehicle: "api/v1/add/constituency",
    geteptOrderDetails: "api/v2/etp/orders/get/detail",
    distanceReport: "api/v1/vehicle/distance/analysis/report",
    vehicleCount: "api/v2/vehicle/type/all",
    vehicleAddForUser: "api/user/vehicles/details/add",
    vehicleAddForAccess: "api/user/vehicles/details/add",
    existingVehicleAccess: "api/v1/get/user/vehicles/details",
    deleteVehicles: "api/user/vehicles/details/update",
    changePassword: "v1/change/password",
    disengagedDistanceReport: "api/v4/vehicle/distance/analysis/report",
    disengagedTotalInstallGps: "api/v2/dashbord/vehicle/status",
    disengagedViewTrip2: "api/v3/etp/orders/get/all",
    disengagedgeteptOrderDetails: "api/v3/etp/orders/get/detail",
    duplicateReports: "api/v1/get/duplicate/gps/in/vehicle",
    vehicleUpdateIsDesignated: "api/v1/remove/vehicle",
    isDisengased: "api/v1/disengaged/vehicle",
    dplList: "dpl/v1/getAll",
    dplListV2: "dpl/v2/getAll",
    getAllWardList: "ward/v1/getAll",
    addWard: "ward/create/v1",
    getWardByID: "ward/getById",
    getAllWard: "ward/v1/getAllBySiteId",
    tripscheduleExcelImport: "dpl/v1/upload/trip_schedule",
    deletscheduleTrip: "dpl/v1/delete/schedule_trip",
    scheduleTrip: "api/schedule_trip/consolidated_vehiclewise",
    fetchDayWise: "api/schedule_trip/consolidated_daywise",
    fetchTransaction: "api/schedule_trip/single_day",
    getOperationDashboard: "api/dashboard",
    updateDplLocation: "dpl/v1/update/geofences",
    addWorkOderVehicle: "api/v1/vehicle/work/order/add",
    disengageGps: "api/v1/disengageGps",
    masterScheduleTripList: "api/v2/vehicle/schedule_trip/all",
    vehicleReplacmentTrail: "api/vehicle/gps/trail",
    logsUrl: "api/getAuditLogData",
    gpsIdUrl: "api/getGpsTrailData",
    gpsTrailImportUrl: "api/gpsVehicleTrail/import",

    tokenUrl: "dpl/getVehicleWiseTokenDetails",
    saveTokenUrl: "dpl/generateVehicleWiseToken",
    updateDplStatusUrl: "dpl/update-all-status",

    // analytics-dashboard-apis
    vehcileTripsAnalyticsUrl: "api/v1/dashboard/tanker-dashboard",
    weeklyTripComparisonUrl: "api/v1/dashboard/weekly-comparison",
    lowCoverageVehiclesUrl: "api/v1/dashboard/low-dpl-coverage",
    performanceStatusUrl: 'api/v1/dashboard/custom-performance-status',
    summerPlanUrl: 'api/v1/dashboard/verification-stats',
    scheduledVsActualTripsUrl: 'api/v1/dashboard/scheduled-vs-actual',
    unverifiedDPlUrl: "api/v1/dashboard/unverified-dpl",
    emergencyPerformanceStatusUrl: 'api/v1/dashboard/custom-schedule-performance-status',
    monthlyTripComparisonUrl: "trip/comparison/month/get/all",
    yearTripComparisonUrl: "trip/comparison/year/get/all",

    // Schedule Master
    // Schedule Master — replace the 3 placeholder lines with these:
    scheduleMasterList: "api/v1/get/schedule/trips",    // GET  ?vehicleId=101
    uploadScheduleMaster: "dpl/upload",                    // POST multipart, field name: "file"
    deleteScheduleMaster: "dpl/v1/delete/schedule_trip",  // GET  ?scheduleTripId=1

    ScoreCardDashboard: "api/score-card/dashboard",
    employeeGetAll: "api/employee/get/all",
    employeeGetByDesignation: "api/employee/get/by/designation",
    employeeGetFplById: "api/employee/get/fpl/by/id",
    DesignationListV2: "v1/scorecard/designation",
    ScoreCardHeirarchy: "api/score-card/hierarchy",
    ResetPassword: "v4/reset/password",

  },
};
